import { Component, OnInit, inject } from '@angular/core';
import { Application } from '../../models/admin-models';
import { SessionStorageService } from '../../services/session-storage.service';

import { DownloadProfileComponent } from './download-profile/download-profile.component';
import { DownloadLogFilesComponent } from './download-log-files/download-log-files.component';
import { DownloadUnitProfilesComponent } from './download-unit-profiles/download-unit-profiles.component';
import { DownloadGroupProfileComponent } from './download-group-profile/download-group-profile.component';
import { PatchProfileComponent } from './patch-profile/patch-profile.component';
import { DownloadDBSpreadsheetComponent } from './download-db-spreadsheet/download-db-spreadsheet.component';
import { ImportProductsComponent } from './import-products/import-products.component';
import { DeleteProductsComponent } from './delete-products/delete-products.component';
import { DownloadHandlebarTemplateComponent } from './download-handlebar-template/download-handlebar-template.component';
import { UploadHandlebarTemplateComponent } from './upload-handlebar-template/upload-handlebar-template.component';
import { UploadReportTemplateComponent } from './upload-report-template/upload-report-template.component';
import { ReqReportTemplateComponent } from './req-report-template/req-report-template.component';
import { CustomReportReqComponent } from './custom-report-req/custom-report-req.component';
import { DataDictionaryComponent } from './data-dictionary/data-dictionary.component';
import { GroupSchemaComponent } from './group-schema/group-schema.component';
import { DownloadMappingFilesComponent } from './download-mapping-files/download-mapping-files.component';
import { NgxLoadingModule } from 'ngx-loading';
import { UtilityToolbarComponent } from '../../shared-components/utility-toolbar/utility-toolbar.component';
import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'app-toolbox',
  templateUrl: './toolbox.component.html',
  styleUrls: ['./toolbox.component.scss'],
  imports: [
    DownloadProfileComponent,
    DownloadLogFilesComponent,
    DownloadUnitProfilesComponent,
    DownloadGroupProfileComponent,
    PatchProfileComponent,
    DownloadDBSpreadsheetComponent,
    ImportProductsComponent,
    DeleteProductsComponent,
    DownloadHandlebarTemplateComponent,
    UploadHandlebarTemplateComponent,
    UploadReportTemplateComponent,
    ReqReportTemplateComponent,
    CustomReportReqComponent,
    DataDictionaryComponent,
    GroupSchemaComponent,
    DownloadMappingFilesComponent,
    NgxLoadingModule,
    UtilityToolbarComponent,
    MatListModule,
  ],
})
export class ToolboxComponent implements OnInit {
  private ss = inject(SessionStorageService);

  loading = false;
  applications: Application[] = [];
  reportTemplates = [
    'appendixTemplate.hbs',
    'chartTemplate.hbs',
    'compareTableTemplate.hbs',
    'coverTemplate.hbs',
    'disclosureDynamicTemplate.hbs',
    'disclosureTemplate.hbs',
    'footerTemplate.hbs',
    'groupTableTemplate.hbs',
    'headerTemplate.hbs',
    'infoCardTemplate.hbs',
    'infoReasonTemplate.hbs',
    'massmutual',
    'mm-styles.css',
    'multiTableTemplate.hbs',
    'notesTemplate.hbs',
    'reasonTemplate.hbs',
    'signatureDynamicTemplate.hbs',
    'signatureTemplate.hbs',
    'styles.css',
    'subtitleTemplate.hbs',
    'tableList.hbs',
    'tableTemplate.hbs',
    'textTemplate.hbs',
    'titleTemplate.hbs',
  ];
  lifeProductTables = [
    { display: 'fundtoprogram', value: 'fundtoprogram', app: 'iw' },
    { display: 'assetclassmap', value: 'assetclassmap', app: 'iw' },
    {
      display: 'manualindexmonthlyreturns',
      value: 'manualindexmonthlyreturns',
      app: 'iw',
    },
    { display: 'firmfunds', value: 'firmfunds', app: 'iw' },
    { display: 'fundfamilylist', value: 'fundfamilylist', app: 'iw' },
    { display: 'fundfamilies', value: 'fundfamilies', app: 'iw' },
    { display: 'globalfundlist', value: 'globalfundlist', app: 'iw' },
    { display: 'manualindexes', value: 'manualindexes', app: 'iw' },

    { display: 'lifebridges', value: 'lifebridges', app: 'li' },
    { display: 'lifeitems', value: 'lifeitems', app: 'li' },
    { display: 'lifeitemtofeature', value: 'lifeitemtofeature', app: 'li' },
    { display: 'lifeitemtoneed', value: 'lifeitemtoneed', app: 'li' },
    { display: 'lifeitemtorider', value: 'lifeitemtorider', app: 'li' },
    { display: 'ratedef', value: 'ratedef', app: 'li' },
    { display: 'rates', value: 'rates', app: 'li' },
    { display: 'riders', value: 'riders', app: 'li' },
    { display: 'riderstateapprovals', value: 'riderstateapprovals', app: 'li' },
    { display: 'stateapprovals', value: 'stateapprovals', app: 'li' },
    {
      display: 'carriergroup_lifeproducts',
      value: 'carriergroup_lifeproducts',
      app: 'li',
    },
    { display: 'carriertogroup', value: 'carriertogroup', app: 'li' },
    { display: 'features', value: 'features', app: 'li' },
    { display: 'lifecarrier', value: 'lifecarrier', app: 'li' },
    { display: 'scenariolifeitem', value: 'scenariolifeitem', app: 'li' },

    { display: 'firelightproductmap', value: 'firelightproductmap', app: 'aw' },
    {
      display: 'firelightorganizationmap',
      value: 'firelightorganizationmap',
      app: 'aw',
    },
    { display: 'paramfiles', value: 'paramfiles', app: 'aw' },
  ];

  ngOnInit(): void {
    if (this.ss.get('globals')) {
      this.ss.get('globals').Modules.forEach(el => {
        switch (el.toLowerCase()) {
          case 'aw':
            this.applications.push({
              name: 'Annuity Wizard',
              value: el.toLowerCase(),
            });
            break;
          case 'iw':
            this.applications.push({
              name: 'Investment Wizard',
              value: el.toLowerCase(),
            });
            break;
          case 'li':
            this.applications.push({
              name: 'Life Insurance Wizard',
              value: el.toLowerCase(),
            });
            break;
          case 'pp':
            this.applications.push({
              name: 'Product Profiler',
              value: el.toLowerCase(),
            });
            break;
          case 'rb':
            this.applications.push({
              name: 'Control KB (RB)',
              value: el.toLowerCase(),
            });
            break;
          default:
            this.applications.push({ name: el, value: el.toLowerCase() });
            break;
        }
      });
      this.applications.push({
        name: 'Policy Management',
        value: 'pm',
      });
      this.applications.push({
        name: 'Case Management',
        value: 'cm',
      });
      this.applications.push({
        name: 'Client Profiler',
        value: 'cp',
      });
    }
  }

  toggleLoading() {
    this.loading = !this.loading;
  }
}
